export class DeviceTimeSetting{
    id:number;
    value:string;
}